import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { TYPES } from 'sarsaparilla';
import { PermitAvailability } from '../../../ui-permit/src/components/PermitAvailability';
import { getCurrentTime, hasLotteryApplication } from '../utils/permitUtils';
import * as pActions from '../actions/permit';

const propTypes = {
  history: TYPES.HISTORY,
  permit: PropTypes.object,
  userIssuances: PropTypes.object,
  division: PropTypes.object,
  pActions: PropTypes.object.isRequired
};

const defaultProps = {
  division: {}
};

class PermitAvailabilityHOC extends React.Component {
  constructor(props) {
    super(props);

    this.handleWalkMeThroughClick = this.handleWalkMeThroughClick.bind(this);
  }

  handleWalkMeThroughClick() {
    this.props.history.push(`/permits/${this.props.permit.id}/questionnaire`);
  }

  render() {
    const currentDate = getCurrentTime(this.props);
    let disableLotteryRegistration = false;
    const divisionId = this.props.division && this.props.division.id ? this.props.division.id : undefined;

    if (this.props.permit && this.props.userIssuances) {
      disableLotteryRegistration = hasLotteryApplication(this.props.permit, this.props.userIssuances);
    }
    const props = {
      ...this.props,
      currentDate,
      disableLotteryRegistration,
      divisionId,
      handleWalkMeThroughClick: this.handleWalkMeThroughClick,
      hasWalkMeThroughButton: true,
      rightRailOnly: true
    };
    return <PermitAvailability {...props} />;
  }
}

function select(state) {
  return {
    ld: state.ld,
    permit: state.inyonwhitney.permit.result,
    issuance: state.inyonwhitney.permit.issuance,
    availability: state.inyonwhitney.permit.availability,
    availabilities: state.inyonwhitney.permit.venue_availabilities,
    error: state.inyonwhitney.permit.error,
    recarea: state.inyonwhitney.permit.recarea,
    recareaError: state.inyonwhitney.permit.recarea_err,
    activeLottery: state.inyonwhitney.permit.lottery,
    userIssuances: state.inyonwhitney.permit.user_issuances,
    aggSeasonRules: state.inyonwhitney.agg_season_rules,
    navigation: state.navigation,
    // lotteries: state.inyonwhitney.lotteries,
    account: state.auth.account
  };
}

const mapActionsToProps = (dispatch) => ({
  pActions: bindActionCreators(pActions, dispatch)
});

export default withRouter(connect(select, mapActionsToProps)(PermitAvailabilityHOC));

PermitAvailabilityHOC.propTypes = propTypes;
PermitAvailabilityHOC.defaultProps = defaultProps;
